import { useAuth } from "@hooks/useAuth";
import { UserRole } from "@models/auth.types";

/**
 * Se o usuário pode alterar dados: Admin e Editor. Visualizador só consulta.
 * Gerenciar usuários é outra pergunta — só o Admin —, feita com
 * hasRole(UserRole.ADMIN).
 *
 * Esconder botões é conveniência: quem garante é a API, que recusa qualquer
 * alteração de quem não é Admin, mesmo vinda de uma tela antiga em cache.
 */
export const usePodeEditar = (): boolean => {
  const { hasAnyRole } = useAuth();
  return hasAnyRole([UserRole.ADMIN, UserRole.EDITOR]);
};
